export const containsOnlyNumbers = (str: string | null | undefined): boolean =>
  str ? /^\d+$/.test(str) : false;
